export default "__VITE_ASSET__BI81OJl0__"